// extracted by mini-css-extract-plugin
module.exports = {"links":"EnergyLabelDrawer_links__omu4l","externalButton":"EnergyLabelDrawer_externalButton__MEboP","energyLabel":"EnergyLabelDrawer_energyLabel__Uv_NL"};